import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import ListHeader from "@/common/components/ListHeader";
import TextField from "@/common/components/TextField";
import useDebounce from "@/common/hooks/useDebounce";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { Mapper } from "@/common/services/mapper";
import { SearchIcon, ShoppingBasket } from "lucide-react";
import { useRewardItems } from "@/common/hooks/queries/useRewardItems";
import { RewardItemData, RewardItemTableItem } from "@/common/types/rewardItems";
import { RewardItemsTransformer } from "../../services/rewardItemsTransformer";
import { RewardItemsGridTable } from "../../components/RewardItemsGridTable";

const TmaisRewardItems = () => {
  const { filterParams, setFilterParams } = useFilterParams();

  const [search, setSearch] = useDebounce(filterParams.search || '');

  const {
    data: rewardItems,
    meta,
    isPending: rewardItemsIsPending,
    isLoading: rewardItemsIsLoading,
    error: rewardItemsError = {} as any,
    refetch: refetchRewardItems,
  } = useRewardItems({
    filters: {
      search,
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer<RewardItemData[], RewardItemTableItem[]>({
      transformer: RewardItemsTransformer.tableTransformer()
    })
  });

  return (
    <div className="flex flex-col h-[calc(100vh-64px)] gap-6">
      <ListHeader
        Icon={<ShoppingBasket className="w-10 h-10" strokeWidth={1} />}
        title="Itens para resgate"
        createButtonText="Cadastrar recompensa"
        operationKlassToCheckPermission="Establishment::Tmais::Products::Create"
        disableCreateButton={rewardItemsIsPending || rewardItemsError?.status === 403}
      />

      <ErrorMessageWrapper
        className="flex-1"
        statusCode={rewardItemsError?.status}
        refetchFunction={refetchRewardItems}
      >
        <div className="flex flex-col flex-1 overflow-auto gap-6">
          <div className="flex flex-col gap-4">
            <TextField
              name="search"
              LeftIcon={<SearchIcon />}
              placeholder="Pesquisar"
              className="rounded-sm shadow-[4px_0px_16px_0px_rgba(0,_0,_0,_0.5)]"
              onChange={(e) => {
                setSearch((e.target as HTMLInputElement).value);
                setFilterParams((prev) => ({ ...prev, search: (e.target as HTMLInputElement).value }));
              }}
              value={filterParams.search}
            />
          </div>

          <RewardItemsGridTable
            className="max-h-[calc(100vh-256px)]"
            rewardItems={rewardItems || []}
            page={filterParams.page || 1}
            totalPages={meta.total_pages || 1}
            totalCount={meta.total}
            setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
            isLoadingData={rewardItemsIsLoading}
          />
        </div>
      </ErrorMessageWrapper>
    </div>
  );
};

export default TmaisRewardItems;
